var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14C26 20.6273 20.6273 26 14 26C7.37273 26 2 20.6273 2 14C2 7.37273 7.37273 2 14 2C20.6273 2 26 7.37273 26 14Z",
    stroke: "#E89900",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4265 9.74097C21.4265 9.74097 17.8581 11.1919 16.1279 7.34424",
    stroke: "#E89900",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1275 14.7769C16.1275 13.5987 17.0831 12.6431 18.2613 12.6431C19.4395 12.6431 20.3951 13.5987 20.3951 14.7769",
    stroke: "#E89900",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57353 9.74097C6.57353 9.74097 10.1419 11.1919 11.8721 7.34424",
    stroke: "#E89900",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8725 14.7769C11.8725 13.5987 10.9169 12.6431 9.73869 12.6431C8.56051 12.6431 7.60487 13.5987 7.60487 14.7769",
    stroke: "#E89900",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0181 20.6562C11.7807 20.0878 12.8356 19.7355 13.9996 19.7355C15.1647 19.7355 16.2196 20.0878 16.9821 20.6562",
    stroke: "#E89900",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpps);
export default __webpack_public_path__ + "static/media/opps.98e93313c114c651baa79a427da4e302.svg";
export { ForwardRef as ReactComponent };